module.exports = __webpack_public_path__ + "img/beer_id-50.c4d74c4c.png";